import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'excess-liability',
  templateUrl: './excess-liability.component.html',
  styleUrls: ['./excess-liability.component.scss']
})
export class ExcessLiabilityComponent implements OnInit {
  summaryPanel;
  get summaryAPIData() {
    return this.summaryPanel;
  }
  @Input() set summaryAPIData(value) {
    this.summaryPanel = { ...value };
  }
  @Input() summarySitecoreData;
  @Input() pageName;
  summaryContent;
  constructor() {}

  ngOnInit(): void {
    this.summaryContent = this.summarySitecoreData;
    window.scrollTo(0, 0);
  }
}
